import { render, staticRenderFns } from "./scrollbar-button.vue?vue&type=template&id=8f7a40b0&"
import script from "./scrollbar-button.js?vue&type=script&lang=js&"
export * from "./scrollbar-button.js?vue&type=script&lang=js&"
import style0 from "./scrollbar-button.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VFabTransition})
